module.exports = __webpack_public_path__ + "img/faq.00996777.png";